import { Component, Inject, InjectionToken, Optional } from "@angular/core";
import { AppSettings } from "./app.settings";
import { Settings } from "./app.settings.model";
import { SharedService } from "./services";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

export const IMG_URL = new InjectionToken<string>("IMG_URL");

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent
{
  public settings: Settings;
  constructor(
    public appSettings: AppSettings,
    public sharedService: SharedService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    @Inject(IMG_URL) imgUrl: string
  )
  {
    this.settings = this.appSettings.settings;

    this.matIconRegistry.addSvgIcon("AE", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/amex.svg"));
    this.matIconRegistry.addSvgIcon("D", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/discover.svg"));
    this.matIconRegistry.addSvgIcon("genericcard", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/generic.svg"));
    this.matIconRegistry.addSvgIcon("MC", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/mastercard.svg"));
    this.matIconRegistry.addSvgIcon("V", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/visa.svg"));
    this.matIconRegistry.addSvgIcon("S", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/Savings.svg"));
    this.matIconRegistry.addSvgIcon("C", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/Checking.svg"));
    this.matIconRegistry.addSvgIcon("cvv", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/cvv.svg"));
    this.matIconRegistry.addSvgIcon("cvv2", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/aps/cvv2.svg"));
    this.matIconRegistry.addSvgIcon("contract", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/contractIcon/contractIcon.svg"));
    this.matIconRegistry.addSvgIcon("filter", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/search/filter-funnel2.svg"));
    this.matIconRegistry.addSvgIcon("filterOff", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/search/filter-off.svg"));
    this.matIconRegistry.addSvgIcon("pdf", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/imaging/pdf.svg"));
    this.matIconRegistry.addSvgIcon("gif", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/imaging/gif.svg"));
    this.matIconRegistry.addSvgIcon("tiff", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/imaging/tiff.svg"));
    this.matIconRegistry.addSvgIcon("bmp", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/imaging/bmp.svg"));
    this.matIconRegistry.addSvgIcon("jpeg", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/imaging/jpeg.svg"));
    this.matIconRegistry.addSvgIcon("png", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/imaging/png.svg"));
    this.matIconRegistry.addSvgIcon("doc", this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl + "/imaging/doc.svg"));
  }
}
